const Env = {
  NEXT_PUBLIC_BASE_URL_PROD: import.meta.env.VITE_BASE_URL_PROD || "",
  NEXT_PUBLIC_BASE_URL_STG: import.meta.env.VITE_BASE_URL_STG || "",
  NEXT_PUBLIC_BASE_URL_DEV: import.meta.env.VITE_BASE_URL_DEV || "",
};

export default Env;
